module.exports = "/_next/static/images/featuredevent-d6ce551007e519a5397c616ea246b862.jpg";